import React from "react";
import "./GalleriesFlat.scss";
import img1 from "../../assets/galleries/flat3/img1.png";
import img2 from "../../assets/galleries/flat3/img2.png";
import img3 from "../../assets/galleries/flat3/img3.png";

function GalleryFlat3() {
  return (
    <section className="galleryFlat galleryFlat3">
      <div className="galleryFlat3__photos1">
        <img src={img1} alt="" className="galleryFlat__photo__img" />
        <p className="galleryFlat__copy galleryFlat3__copy">
          Roberto discussing new designs with his team of maestros. From left:
          Fernando Toledo, Factory Manager, Roberto Coin, Carlo Coin, Roberto’s
          son and President of Factories and Vice President at Roberto Coin,
          Davide Bertuzzo, head designer at Roberto Coin.
        </p>
      </div>

      <div className="galleryFlat3__photos2">
        <div className="galleryFlat3__photo galleryFlat2__photo--left">
          <img src={img2} alt="" className="galleryFlat__photo__img" />
        </div>
        <div className="galleryFlat3__photo">
          <img src={img3} alt="" className="galleryFlat__photo__img" />
        </div>
      </div>
    </section>
  );
}

export default GalleryFlat3;
